import React, { ReactNode } from 'react'
import { Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import { ReportTypeMasonryTile, ReportTypeMasonryTileIcon } from '../../styles/MasonryStyles'

interface ReportTileProps {
  icon: ReactNode
  title: string
  description: string
  selected: boolean
  onSelect: () => void
}

const ReportTile: React.FC<ReportTileProps> = ({ icon, title, description, selected, onSelect }) => {
  const theme = useTheme()
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))

  const tileContent = (
    <ReportTypeMasonryTile
      elevation={0}
      selected={selected}
      onClick={onSelect}
      tabIndex={0}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          onSelect()
        }
      }}
    >
      <Stack direction={isDownLg ? 'column' : 'row'} sx={{ gap: 4 }}>
        <ReportTypeMasonryTileIcon selected={selected}>{icon}</ReportTypeMasonryTileIcon>
        {!isDownLg && (
          <Stack>
            <Typography fontWeight={700} sx={{ fontSize: 16, color: selected ? 'black' : 'text.highEmphasis' }}>
              {title}
            </Typography>
            <Typography
              variant="caption"
              sx={{ fontSize: 13, fontStyle: 'italic', color: selected ? 'black' : 'text.mediumEmphasis' }}
            >
              {description}
            </Typography>
          </Stack>
        )}
      </Stack>
    </ReportTypeMasonryTile>
  )

  return isDownLg ? <Tooltip title={title}>{tileContent}</Tooltip> : tileContent
}

export default ReportTile